import { render, staticRenderFns } from "./CreateIPSetList.vue?vue&type=template&id=93b28a04&"
import script from "./CreateIPSetList.vue?vue&type=script&lang=ts&"
export * from "./CreateIPSetList.vue?vue&type=script&lang=ts&"
import style0 from "./CreateIPSetList.vue?vue&type=style&index=0&id=93b28a04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports